import { SlIcon } from '@sololearnorg/icons';
import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { MaxIcon } from '../../../_paywalls/private/components/ui/icons';
import { BadgeExperienceLevel, BadgeSubscriptionStatus, defineUserProfileBadge, IBadgeDetails } from '../SlUtils/defineUserProfileBadge';
import { IconColorPro } from '@sololearnorg/sol';

import s from './UserDetailsBadge.scss';

interface IUserDetailsBadgeProps {
	badgeString: string;
	styles?: {
		mentor?: React.CSSProperties;
		subscription?: React.CSSProperties;
		experience?: React.CSSProperties;
	};
	mentorLabel?: string;
}

export const UserDetailsBadge: React.FC<IUserDetailsBadgeProps> = React.memo(
	({ badgeString, styles = {}, mentorLabel = 'MENTOR' }) => {
		useStyles(s);
		const [badge, setBadge] = useState<IBadgeDetails>();

		useEffect(() => {
			setBadge(defineUserProfileBadge(badgeString));
		}, []);

		const mentorBadge = <div
			className='profile-mentor-icon'
			style={styles.mentor || {}}
		>
			<span>{mentorLabel}</span> <div><SlIcon iconId={'simpleStar'} /></div>
		</div>;

		const experienceBadge = (backgroundColor: string, color: string) => {
			return <div
				className='profile-experience-icon'
				style={{
					backgroundColor,
					...styles.experience
				}}
			>
				<div style={{ color }}><SlIcon iconId={'simpleStar'} /></div>
			</div>;
		};

		if (!badge) {
			return null;
		} else if (badge.isMentor) {
			return mentorBadge;
		} else if (badge.subscriptionStatus === BadgeSubscriptionStatus.max) {
			return <div
				className='profile-pro-icon max'
				style={styles?.subscription || {}}
			><MaxIcon /></div>;
		} else if (badge.subscriptionStatus === BadgeSubscriptionStatus.pro) {
			return <div
				className='profile-pro-icon pro'
				style={styles?.subscription || {}}
			><IconColorPro /></div>;
		} else if (badge.experienceLevel === BadgeExperienceLevel.platinium) {
			return experienceBadge('#3B6887', '#ECF7FF');
		} else if (badge.experienceLevel === BadgeExperienceLevel.gold) {
			return experienceBadge('#ECAA00', '#F6E9C8');
		} else if (badge.experienceLevel === BadgeExperienceLevel.silver) {
			return experienceBadge('#96A5B3', '#FFFFFF');
		} else if (badge.experienceLevel === BadgeExperienceLevel.bronze) {
			return experienceBadge('#988145', '#F6E9C8');
		} else {
			return null;
		}
	},
);
